<template>
    <section class="bg-light" id="confidentialite">
		<div class="container">
			<div class="row">
				<div class="col-lg-12 text-center">
					<h2 class="section-heading text-uppercase" id="title">Technicien informatique</h2>
					<h3 class="section-subheading text-muted">Il assure le montage, l'assemblage et le bon fonctionnement des postes de travail.</h3>					
				</div>
			</div>
			
			<div class="row text-center">
				<div class="col-md-4">
					<span class="fa-stack fa-4x">
						<i class="fas fa-circle fa-stack-2x text-primary"></i>
						<i class="fas fa-wrench fa-stack-1x fa-inverse"></i>
					</span> 
					
					<h4 class="service-heading">Compétences & actions</h4>
					
					<p class="text-muted paragraphs-tech">
						<ul class="list-group">
						  <li class="list-group-item">Parfaite connaissance de l'ordinateur et de structure</li>
						  <li class="list-group-item">Connaissance des principaux logiciels</li>
						  <li class="list-group-item">Morbi leo risus</li>
						  <li class="list-group-item">Connaissance des réseaux et de l'Internet</li>
						  <li class="list-group-item">Connaissance de l'anglais informatique</li>
						</ul>
					</p>
			</div>
				
			<div class="col-md-4">
				<span class="fa-stack fa-4x">
					<i class="fas fa-circle fa-stack-2x text-primary"></i>
					<i class="far fa-smile fa-stack-1x fa-inverse"></i>
				</span>
				
				<h4 class="service-heading">Savoir-être</h4>
			  
				<p class="text-muted paragraphs-tech">
					<ul class="list-group">
						<li class="list-group-item">Capacité d’écoute</li>
						<li class="list-group-item">Rigoureux</li>
						<li class="list-group-item">Faire preuve de méthode</li>
						<li class="list-group-item">Patient</li>
						<li class="list-group-item">Flexibilité</li>
						<li class="list-group-item">Esprit critique d'analyse afin de déterminer d'où la panne peut venir, éventuellement en posant les bonnes questions aux utilisateurs</li>
						<li class="list-group-item">Minutieux car il va être amené à manipuler des composants de très petite taille</li>
						<li class="list-group-item">Sens de la pédagogie (pour expliquer à l’utilisateur comment éventuellement réparer lui-même la panne si elle survient à nouveau)</li>
						<li class="list-group-item">Rapidité d’exécution et de réaction</li>
						<li class="list-group-item">Calme et maîtrise de soi</li>
						<li class="list-group-item">Esprit de synthèse</li>
						<li class="list-group-item">Respect des processus logiques et méthodologiques</li>
						<li class="list-group-item">Facultés d’adaptation à de nouveaux produits et à de nouvelles technologies</li>
					</ul>
				</p>
			</div>
		
			<div class="col-md-4">
				<span class="fa-stack fa-4x">
					<i class="fas fa-tachometer-alt fa-stack-2x text-primary"></i>
					<i class="far fa-smile fa-inverse"></i>
				</span>
				
				<h4 class="service-heading">Cadre professionnel</h4>
			  
				<p class="text-muted">
				Le technicien de maintenance informatique peut exercer ses talents dans une société utilisatrice d'informatique ou dans
				une SSII (Société de Service et d'Ingénierie Informatique). Il peut également être détaché à plein temps par une SSII dans
				une entreprise. Les conditions de travail peuvent parfois être difficiles (horaires lourds, déplacements nombreux, périodes d’astreinte, horaires décalés, etc.). Après plusieurs années d’expérience professionnelle, il peut espérer devenir responsable du parc informatique dans une petite entreprise ou responsable du service après-vente dans un magasin de matériel informatique. Il évoluera ainsi vers une fonction de technico-commercial des télécommunications et réseaux ou bien deviendra ingénieur de maintenance. Quoiqu’il en soit dans ce domaine la technologie évolue très rapidement et le technicien de maintenance se doit d’actualiser ses connaissances pour rester performant.
				</p>
			</div>
      </div>
    </div>
    </section>
</template>

<script>
export default {
    
}
</script>

<style lang="css">

</style>


